"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResetShippingSelectionEvent = exports.Name = void 0;
const Name = exports.Name = 'reset-shipping-selection';
const ResetShippingSelectionEvent = exports.ResetShippingSelectionEvent = Name;
//# sourceMappingURL=index.js.map